/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-06-29 22:29:09
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-02-24 10:07:20
 * @FilePath: /unifyxp-v2-store-portal/src/request/currency/index.ts
 */
import { get, post } from 'src/tools/server';

export const getCurrencyList = () => {
  return get(`/portal/currency/storeCurrency/list`, {});
};

export const currencies = () => {
  return get<any[]>(`/portal/currency/storeCurrency/listCurrency`, {});
};

export const getCurrency = () => {
  return get(`/portal/currency/store`, {});
};
export const iosList = () => {
  return get(`/portal/currency/isolist`, {});
};

export const getRealTimeExchangeRate = (
  fromCurrencyCode: string,
  toCurrencyCode: string,
) => {
  return get(`/portal/currency/rate/${fromCurrencyCode}/${toCurrencyCode}`, {});
};

export const saveStoreCurrency = (body: any) => {
  return post(`/portal/currency/store`, body, {});
};

export const getSalesChannelCurrency = (uuid: string) => {
  return get(`/portal/currency/salesChannel/${uuid}`, {});
};

export const getSymbol = (code: string) => {
  return get(`/portal/currency/symbol/${code}`, {});
};

export const saveSalesChannelCurrency = (body: any) => {
  return post(`/portal/currency/salesChannelCurrency`, body, {});
};
